<template>
	<div class="wrapper px-3 mx-auto">
		<div class="box has-text-centered px-1-mobile" ref="modalContent">
			<top-up-leads :plansToShow="planstoShow" @scroll-to-top="handleScrollToTop"></top-up-leads>
		</div>
	</div>
</template>
<script lang="ts">
import { emitterEvents } from "@/constants/utils";
import emitter from "@/utils/emitter";
import { closeModal } from "@/utils/mixins";
import { defineComponent } from "vue";
import TopUpLeads from "../TopUpLeads/TopUpLeads.vue";

export default defineComponent({
	mixins: [closeModal],
	components: { TopUpLeads },
	data () {
		return { 
			boundedClose: this.close.bind(this)
		}
	},
	computed: {
		planstoShow () {
			return this.modalData?.plansToShow;
		}
	},
	mounted () {
		emitter.on(emitterEvents.DONE_TOP_UP, this.doneTopUphandler)
	},
	methods: {
		handleScrollToTop () {
			const modalContentElement = this.$refs.modalContent as HTMLElement | undefined;
			if (modalContentElement) modalContentElement.scrollTo({ top: 0 });
		},
		doneTopUphandler (data: any = {}) {
			this.boundedClose(data);
		}
	},
	unmounted () {
		emitter.off(emitterEvents.DONE_TOP_UP, this.doneTopUphandler)
	}
})
</script>

<style scoped>
	.wrapper { 
		height: 70vh;
		overflow: hidden;
	}
	.box {
		height: 100%;
		overflow: scroll;
	}
</style>
